export type MedicalInsuranceConfig = {
  catalogType: string;
  typeCode: string;
  showPharmacyLink: boolean;
  titleName: string;
  pageName: string;
  showDescription: boolean;
  showContentTitle: boolean;
};

export const MedicalInsuranceConfigs: { [code: string]: MedicalInsuranceConfig } = {
  default: {
    catalogType: 'Taltz',
    typeCode: 'normal',
    showPharmacyLink: true,
    titleName: '医保政策',
    pageName: '医保政策',
    showDescription: false,
    showContentTitle: true,
  },
  Zyprexanormal: {
    catalogType: 'Zyprexa',
    typeCode: 'normal',
    showPharmacyLink: true,
    titleName: '医保政策',
    pageName: '医保政策',
    showDescription: false,
    showContentTitle: true,
  },
  Taltznormal: {
    catalogType: 'Taltz',
    typeCode: 'normal',
    showPharmacyLink: true,
    titleName: '医保政策',
    pageName: '医保政策',
    showDescription: false,
    showContentTitle: true,
  },

  TaltzPublicnormal: {
    catalogType: 'TaltzPublic',
    typeCode: 'normal',
    showPharmacyLink: true,
    titleName: '医保政策',
    pageName: '医保政策',
    showDescription: false,
    showContentTitle: true,
  },

  Olumiantnormal: {
    catalogType: 'Olumiant',
    typeCode: 'normal',
    showPharmacyLink: true,
    titleName: '医保政策',
    pageName: '医保政策',
    showDescription: false,
    showContentTitle: true,
  },

  VerzenioscountryHealthInsurance: {
    catalogType: 'Verzenios',
    typeCode: 'countryHealthInsurance',
    showPharmacyLink: false,
    titleName: '国家医保',
    pageName: '医保政策',
    showDescription: false,
    showContentTitle: true,
  },

  VerzeniosbusinessHealthInsurance: {
    catalogType: 'Verzenios',
    typeCode: 'businessHealthInsurance',
    showPharmacyLink: false,
    titleName: '惠民保',
    pageName: '惠民保',
    showDescription: true,
    showContentTitle: false,
  },
};
